interface Agent {
    id: number;
    name: string
    /** Friendly name for UI / attendance; `name` (user_name) may stay generic */
    display_name?: string;
    car?: string;
    isManager: boolean
    isDriver: boolean
    isCollector: boolean
    isAgent: boolean
    active: boolean,
    /** 1 = can show dashboard, 0 = hide */
    showDashboard: boolean,
    start_point?:string,
    end_point?:string,
    comment?:string,
    password?:string,
    increase_id?:number,
    nkObject: any;
}
export const getType = (a: Agent): number => {
    if (a.isAgent)
        return 0
    else if (a.isDriver)
        return 1
    else
        return 2
};
export const deserializeAgent = (a): Agent =>{

    return ({
        id: a.id,
        isCollector: a.is_collector >= 1,
        isDriver: a.is_driver >= 1,
        isAgent: a.is_agent === 1,
        isManager: a.manager >= 1,
        /** Only show dashboard when explicitly 1 */
        showDashboard: a.show_dashboard === 1,
        start_point:a.start_point,
        end_point:a.end_point,
        name: a.user_name,
        display_name: a.display_name ?? '',
        car: a.car ?? '',
        comment: a.comment,
        password: a.user_password ?? '',
        active: a.active>=1,
        increase_id: a.increase_id,
        nkObject: a
    })
} ;
export default Agent;
